import { recordTestInstance } from '../axios';

const getInspectionCodes = () => recordTestInstance.post('/inspection-codes');

export default getInspectionCodes;